import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Loading from '../../components/loading';
import ClassifierItem from './components/classifier-item';
import { LibraryViewModel } from './library.vm';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const EmptyMessage = styled.div`
  padding: 1rem;
  color: #96999c;
`;

export const Library: React.FC = () => {
  const vm = useViewModel(LibraryViewModel);

  const navigate = useNavigate();

  useEffect(() => {
    if (vm.shouldRedirectToPaywall) {
      navigate('/exclusive-access');
    }
  }, [vm.shouldRedirectToPaywall, navigate]);

  if (vm.isLoading) {
    return <Loading />;
  }

  if (!vm.classifiers.length) {
    return <EmptyMessage>Nenhum curso encontrado.</EmptyMessage>;
  }

  return (
    <Container>
      {vm.classifiers.map((classifier) => (
        <ClassifierItem
          classifier={classifier}
          key={classifier.guid}
          liveStreaming={vm.liveStreaming}
        />
      ))}
    </Container>
  );
};

export default observer(Library);
